import React from "react";
import { connect } from "react-redux";
import { actions as routerActions } from "redux-router5";

import * as Routes from "../routing/routes";
import LayoutWithFooter from "../page/layout-with-footer";
import AppSecondaryBackground from "../root/app-secondary-background";
import { ModalType } from "../modal/modal-constants";
import Guidance from "modules/general-info/guidance";

function GuidanceSelfDiagnosisPage({ goTo }) {
  return (
    <AppSecondaryBackground>
      <LayoutWithFooter
        className="Guidance GuidanceSelfDiagnosisPage"
        contentClassName="GuidanceSelfDiagnosisPage__Content"
      >
        <Guidance
          type={ModalType.SELF_DIAGNOSIS_SCREEN}
          onNext={() => goTo(Routes.AGE_INFO)}
        />
      </LayoutWithFooter>
    </AppSecondaryBackground>
  );
}

const mapDispatch = {
  goTo: routerActions.navigateTo
};

GuidanceSelfDiagnosisPage = connect(
  null,
  mapDispatch
)(GuidanceSelfDiagnosisPage);

export default GuidanceSelfDiagnosisPage;



// WEBPACK FOOTER //
// ./src/modules/pages/GuidanceSelfDiagnosisPage.js